"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.qaLinks = void 0;
const development_1 = require("./development");
const ORIGIN = 'https://qa-m.place.naver.com';
const MYPLACE_WEB = 'https://qa-m.place.naver.com/my';
exports.qaLinks = {
    ...development_1.developmentLinks,
    MYPLACE_WEB,
    MYPLACE_API: 'https://qa-api.place.naver.com/my',
    MYPLACE_REVIEW_FEED: `${MYPLACE_WEB}/:userId/reviewfeed?reviewId=:reviewId`,
    API_URL_ON_BROWSER: 'https://qa-api.place.naver.com/my',
    API_URL_ON_NODE: 'http://profile-api-qa.myplace.svc.ad1.io.navercorp.com/my',
    FILE_API: 'https://qa-files.place.naver.com/my',
    FILE_UPLOAD: 'https://qa-files.place.naver.com/my/upload',
    MY_HOME: `${ORIGIN}/my`,
    PC_MAP: 'https://dev.map.naver.com/p',
    MAP_APP_LINK: 'https://dev-m.map.naver.com/appLink.naver',
    MAP_STATIC: 'https://tssl.map.naver.com/staticmap/v2/map/staticmap.bin?',
    PANORAMA_THUMBNAIL: 'https://test-panorama.map.naver.com/api/v2/thumbnail',
    MAP_USEFUL_TIPS: 'https://dev-pt.map.naver.com/end-quick-path/bridges/useful-tips/bookmark',
    MY_DATA: 'https://new-alpha-m.pay.naver.com/mydata',
    NAVER_APP: 'https://m.naver.com/naverapp',
    OPEN_MAIN: 'https://test-openmain.m.naver.com/js/openmain.js',
    ORIGIN,
    PAY_MY_INCOME_EXPENSE: 'https://new-alpha-m.pay.naver.com/pfms/statements',
    TERMS: `${ORIGIN}/my/terms`,
    YEAR_END_2022: `${ORIGIN}/my/year-end/2022`,
    MAP_USER_OPEN_LIST: `https://dev-pages.map.naver.com/save-pages/web/user-open-list/:encryptedUserId`,
    NAVER_CLIP: 'https://t12.m.naver.com/shorts/?',
};
